import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage, makeDataDangerous} from 'nutshell-core/utils/graphql-errors';

import type {
    GetFormsDashboard_formsDashboard as FormsDashboard,
    GetFormsDashboard as GetFormsDashboardQuery,
    GetFormsDashboardVariables as GetFormsDashboardQueryVariables,
    DashboardInput,
} from 'nutshell-graphql-types';

import GET_FORMS_DASHBOARD from '../queries/get-forms-dashboard.graphql';

export const useGetFormsDashboard = (
    input: DashboardInput
): {
    isLoading: boolean;
    errorMessage: string | null | undefined;
    formsDashboard: FormsDashboard;
} => {
    const {loading, data, error} = useQuery<
        GetFormsDashboardQuery,
        GetFormsDashboardQueryVariables
    >(GET_FORMS_DASHBOARD, {
        variables: {input},
        notifyOnNetworkStatusChange: true,
    });

    const {formsDashboard} = makeDataDangerous(data);

    return {
        isLoading: loading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        formsDashboard,
    };
};
